var _ellipse, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDisabledExpertise = function SvgDisabledExpertise(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 166,
    viewBox: "0 0 197 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.4391,
    cy: 83.2354,
    rx: 82.62,
    ry: 82.6199,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5365 27.7607L33.3279 28.4201L32.009 24.0029C30.189 17.9072 23.7646 14.437 17.6688 16.257C11.5731 18.0771 8.10293 24.5015 9.92296 30.5972L11.2418 35.0144L9.03321 35.6739C6.60374 36.3992 5.20948 38.9805 5.93485 41.4099L12.5291 63.496C13.2545 65.9254 15.8357 67.3197 18.2652 66.5943L44.7685 58.6812C47.1979 57.9558 48.5922 55.3746 47.8668 52.9451L41.2725 30.8591C40.5472 28.4296 37.9659 27.0353 35.5365 27.7607ZM28.2197 51.5947C25.7902 52.3201 23.209 50.9258 22.4836 48.4964C21.7583 46.0669 23.1525 43.4857 25.582 42.7603C28.0114 42.0349 30.5927 43.4292 31.318 45.8587C32.0434 48.2881 30.6492 50.8694 28.2197 51.5947ZM15.659 33.6956L14.3402 29.2784C13.2455 25.6121 15.3214 21.7689 18.9877 20.6743C22.654 19.5796 26.4971 21.6555 27.5918 25.3218L28.9107 29.739L15.659 33.6956Z",
    fill: "#C1C2E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1668_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3391 43.047C41.3391 39.9643 43.9611 37.4653 47.1955 37.4653H149.683C152.918 37.4653 155.539 39.9643 155.539 43.047V50.8614H41.3391V43.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3391 50.8614H155.539V86.9733V123.085C155.539 126.355 152.918 129.005 149.683 129.005H47.1955C43.9611 129.005 41.3391 126.355 41.3391 123.085V50.8614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8921 57.4286H48.9192C47.8094 57.4286 46.9098 58.2939 46.9098 59.3613C46.9098 60.4287 47.8094 61.294 48.9192 61.294H73.8921C75.0017 61.294 75.9013 60.4287 75.9013 59.3613C75.9013 58.2939 75.0017 57.4286 73.8921 57.4286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.403 65.4356H52.3637C49.3516 65.4356 46.9098 67.7843 46.9098 70.6816C46.9098 73.5788 49.3516 75.9275 52.3637 75.9275H87.3831H122.403C125.414 75.9275 127.856 73.5788 127.856 70.6816C127.856 67.7843 125.414 65.4356 122.403 65.4356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.671 82.8303H48.9192C47.8094 82.8303 46.9098 83.6957 46.9098 84.7629C46.9098 85.8302 47.8094 86.6955 48.9192 86.6955H118.671C119.781 86.6955 120.68 85.8302 120.68 84.7629C120.68 83.6957 119.781 82.8303 118.671 82.8303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4847 89.1805H48.9192C47.8094 89.1805 46.9098 90.0459 46.9098 91.1131C46.9098 92.1808 47.8094 93.0462 48.9192 93.0462H78.4847C79.5943 93.0462 80.4939 92.1808 80.4939 91.1131C80.4939 90.0459 79.5943 89.1805 78.4847 89.1805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3362 95.5312H48.9192C47.8094 95.5312 46.9098 96.3961 46.9098 97.4638C46.9098 98.531 47.8094 99.3964 48.9192 99.3964H77.3362C78.4462 99.3964 79.3459 98.531 79.3459 97.4638C79.3459 96.3961 78.4462 95.5312 77.3362 95.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.375 107.68H49.7803C48.195 107.68 46.9098 109.116 46.9098 110.888V120.511C46.9098 122.283 48.195 123.719 49.7803 123.719H147.375C148.961 123.719 150.246 122.283 150.246 120.511V110.888C150.246 109.116 148.961 107.68 147.375 107.68Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3391 43.047C41.3391 39.9643 43.9611 37.4653 47.1955 37.4653H149.683C152.918 37.4653 155.539 39.9643 155.539 43.047V50.8614H41.3391V43.047Z",
    fill: "url(#paint0_linear_1668_586)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3391 50.8614H155.539V86.9733V123.085C155.539 126.355 152.918 129.005 149.683 129.005H47.1955C43.9611 129.005 41.3391 126.355 41.3391 123.085V50.8614Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8921 57.4286H48.9192C47.8094 57.4286 46.9098 58.2939 46.9098 59.3613C46.9098 60.4287 47.8094 61.294 48.9192 61.294H73.8921C75.0017 61.294 75.9013 60.4287 75.9013 59.3613C75.9013 58.2939 75.0017 57.4286 73.8921 57.4286Z",
    fill: "url(#paint1_linear_1668_586)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.403 65.4356H52.3637C49.3516 65.4356 46.9098 67.7843 46.9098 70.6816C46.9098 73.5788 49.3516 75.9275 52.3637 75.9275H87.3831H122.403C125.414 75.9275 127.856 73.5788 127.856 70.6816C127.856 67.7843 125.414 65.4356 122.403 65.4356Z",
    fill: "url(#paint2_linear_1668_586)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.671 82.8303H48.9192C47.8094 82.8303 46.9098 83.6957 46.9098 84.7629C46.9098 85.8302 47.8094 86.6955 48.9192 86.6955H118.671C119.781 86.6955 120.68 85.8302 120.68 84.7629C120.68 83.6957 119.781 82.8303 118.671 82.8303Z",
    fill: "url(#paint3_linear_1668_586)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4847 89.1805H48.9192C47.8094 89.1805 46.9098 90.0459 46.9098 91.1131C46.9098 92.1808 47.8094 93.0462 48.9192 93.0462H78.4847C79.5943 93.0462 80.4939 92.1808 80.4939 91.1131C80.4939 90.0459 79.5943 89.1805 78.4847 89.1805Z",
    fill: "url(#paint4_linear_1668_586)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3362 95.5312H48.9192C47.8094 95.5312 46.9098 96.3961 46.9098 97.4638C46.9098 98.531 47.8094 99.3964 48.9192 99.3964H77.3362C78.4462 99.3964 79.3459 98.531 79.3459 97.4638C79.3459 96.3961 78.4462 95.5312 77.3362 95.5312Z",
    fill: "url(#paint5_linear_1668_586)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.375 107.68H49.7803C48.195 107.68 46.9098 109.116 46.9098 110.888V120.511C46.9098 122.283 48.195 123.719 49.7803 123.719H147.375C148.961 123.719 150.246 122.283 150.246 120.511V110.888C150.246 109.116 148.961 107.68 147.375 107.68Z",
    fill: "url(#paint6_linear_1668_586)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.3391,
    y: 37.4653,
    width: 114.2,
    height: 91.54,
    rx: 5.13585,
    stroke: "#F5F4FB",
    strokeWidth: 0.506355
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.926 71.8716L186.362 71.4681L187.169 66.3404C188.283 59.2643 183.444 52.6174 176.368 51.5036C169.291 50.3899 162.645 55.229 161.531 62.3051L160.724 67.4328L158.16 67.0292C155.34 66.5854 152.669 68.5296 152.225 71.3498L148.19 96.9881C147.746 99.8083 149.69 102.479 152.51 102.923L183.276 107.765C186.097 108.209 188.767 106.265 189.211 103.445L193.246 77.8063C193.69 74.9861 191.746 72.3155 188.926 71.8716ZM169.911 92.5249C167.091 92.081 165.147 89.4104 165.59 86.5902C166.034 83.7699 168.705 81.8257 171.525 82.2696C174.345 82.7135 176.29 85.3841 175.846 88.2043C175.402 91.0245 172.731 92.9688 169.911 92.5249ZM165.851 68.2398L166.658 63.1122C167.328 58.8562 171.305 55.9614 175.56 56.6313C179.816 57.3012 182.711 61.2774 182.041 65.5334L181.234 70.661L165.851 68.2398Z",
    fill: "#C1C2E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1668_586",
    x: 25.6341,
    y: 25.6865,
    width: 145.61,
    height: 122.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.92626
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.85252
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.786354 0 0 0 0 0.807996 0 0 0 0 0.863646 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1668_586"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.01197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.73869
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.419608 0 0 0 0 0.47451 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1668_586",
    result: "effect2_dropShadow_1668_586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1668_586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1668_586",
    x1: 98.4391,
    y1: 37.4653,
    x2: 98.4391,
    y2: 129.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1668_586",
    x1: 98.4391,
    y1: 37.4653,
    x2: 98.4391,
    y2: 129.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1668_586",
    x1: 98.4391,
    y1: 37.4653,
    x2: 98.4391,
    y2: 129.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1668_586",
    x1: 98.4391,
    y1: 37.4653,
    x2: 98.4391,
    y2: 129.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1668_586",
    x1: 98.4391,
    y1: 37.4653,
    x2: 98.4391,
    y2: 129.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1668_586",
    x1: 98.4391,
    y1: 37.4653,
    x2: 98.4391,
    y2: 129.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1668_586",
    x1: 98.4391,
    y1: 37.4653,
    x2: 98.4391,
    y2: 129.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDisabledExpertise);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "disabled_expertise.7df7ca65a0d00daa08f65330e964c14c.svg";